module.exports = __webpack_public_path__ + "static/img/hero-img.fc865189.jpg";